import MobileLabelLine from 'components/MobileWhiteCardLine'
import {
  SoftwareMobileTitle,
  SoftwareMobileContainer,
} from '../HomeSoftwareUpdates/styles'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import { SoftwareVersionCell } from '../HomeSoftwareUpdates/components/SoftwareVersionCell'
import { SOFTWARE_HISTORY_HEADERS } from './const'

interface HomeSoftwareHistoryTableMobileProps {
  values: Record<string, any>
}

//todo localization
function HomeSoftwareHistoryTableMobile({
  values,
}: HomeSoftwareHistoryTableMobileProps) {
  return (
    <SoftwareMobileContainer>
      <SoftwareMobileTitle>
        <SoftwareVersionCell
          version={values[SOFTWARE_HISTORY_HEADERS.RUNTIME_VERSION] || ''}
        />
      </SoftwareMobileTitle>
      <MobileLabelLine
        label="Installed"
        value={
          <IntlFormattedDate
            date={values[SOFTWARE_HISTORY_HEADERS.INSTALLED]}
            withTime
            defaultReturn="-"
          />
        }
      />
    </SoftwareMobileContainer>
  )
}

export default HomeSoftwareHistoryTableMobile
